$(document).ready(function () {
  var gsap = require("gsap/dist/gsap").gsap;
  var ScrollToPlugin = require("gsap/dist/ScrollToPlugin");

  gsap.registerPlugin(ScrollToPlugin);

  //url change listener
  if ($("body").hasClass("ReportRequestPage")) {
    var urlParams = new URLSearchParams(window.location.search);
    var id = urlParams.get("id");
    if (id != null) {
      changeQuestion(id);
    }
    if (id != null && id.includes("base")) {
      var url = window.location.href;
      urlSplit = url.split("?");
      url = urlSplit[0];
      window.history.pushState({}, "", url);
    }
  }

  //report
  if ($(".js-report-question-layer").length > 0) {
    //report next
    $(document)
      .find(".js-report-question-button")
      .each(function (e) {
        $(this).on("click", function (e) {
          var nextID = $(this).data("next");
          changeQuestion(nextID);
          if ($(this).data("from") != null) {
            nextClass = "#" + nextID;
            if (nextClass.includes("report")) {
              $(nextClass)
                .find(".js-report-back-button")
                .data("back", $(this).data("from"));
            } else {
              $(nextClass)
                .find(".js-request-back-button")
                .data("back", $(this).data("from"));
            }
          }
        });
      });
    //report back
    $(document)
      .find(".js-report-back-button")
      .each(function (e) {
        $(this).on("click", function (e) {
          var backID = $(this).data("back");
          if ($(this).data("back").includes("request")) {
            changeQuestion($(this).data("back"));
          }
          changeQuestion(backID);
          $(this).data("back", $(this).data("original-back"));
        });
      });
  }

  //request
  if ($(".js-request-question-layer").length > 0) {
    //request next
    $(document)
      .find(".js-request-question-button")
      .each(function (e) {
        $(this).on("click", function (e) {
          var nextID = $(this).data("next");
          changeQuestion(nextID);
          if ($(this).data("from") != null) {
            nextClass = "#" + nextID;
            if (nextClass.includes("report")) {
              $(nextClass)
                .find(".js-report-back-button")
                .data("back", $(this).data("from"));
            } else {
              $(nextClass)
                .find(".js-request-back-button")
                .data("back", $(this).data("from"));
            }
          }
        });
      });
    //request back
    $(document)
      .find(".js-request-back-button")
      .each(function (e) {
        $(this).on("click", function (e) {
          var backID = $(this).data("back");
          if ($(this).data("back").includes("report")) {
            changeQuestion($(this).data("original-back"));
          }
          changeQuestion(backID);
          $(this).data("back", $(this).data("original-back"));
        });
      });
  }

  function changeQuestion(id) {
    var tl = gsap.timeline();
    var elementString = "";

    if (id.includes("report")) {
      elementString = ".js-report-question-layer";
    } else if (id.includes("request")) {
      elementString = ".js-request-question-layer";
    }

    //update url params to have id, unless base question
    if (id.includes("base")) {
      var url = window.location.href;
      urlSplit = url.split("?");
      url = urlSplit[0];
      window.history.pushState({}, "", url);
    } else {
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.set("id", id);
      window.history.pushState(
        {},
        "",
        window.location.pathname + "?" + urlParams
      );
    }

    //hide all
    tl.to(elementString, {
      opacity: 0,
      display: "none",
      duration: 0.2,
    });

    //unhide specifc
    tl.fromTo(
      "#" + id,
      { opacity: 0, display: "none" },
      { opacity: 1, display: "block", duration: 0.5 }
    );

    //scroll into view on change
    var offset = window.innerHeight * 0.3;
    tl.to(
      window,
      {
        duration: 0.3,
        scrollTo: { y: "#" + id, offsetY: offset, autoKill: true },
      },
      "<0.2"
    );
  }
});
